module.exports = __webpack_public_path__ + "fonts/checkbox-01.7e72002067c9047c205fdb3521176196.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/ui/forms/checkbox-01.png
// module id = 795
// module chunks = 9